<span class="font-medium text-lg text-muted-color">
    <!-- <img src="/layout/images/logo/footer-ultima{{layoutService.isDarkTheme() ? '-dark.svg' : '.svg'}}"/> -->
    <img src="layout/images/logo/logo_cotagov.png" alt="logo" class="logo-footer" />
</span>
<div class="copyright">
    <span class="text-muted-color">{{'components.global.footerComponent.textCopyright' | translate}}</span><br />
    <span class="text-muted-color" [innerHTML]="'components.global.footerComponent.textDevelopedBy' | translate"></span>
    <span class="text-muted-color" style="display: block; margin-top: 10px;">{{'labels.version' | translate}}: <b>{{versionApp}}</b></span>
</div>
<div class="flex gap-2">
    <button pButton icon="fa-solid fa-headset" rounded text severity="secondary" class="button-icon-footer"
        size="large" [pTooltip]="'tooltips.buttonSupport' | translate">
    </button>
</div>